export default {
    venueTemperature: "場館溫度",
    venueHumidity: "場館濕度",
    outdoorTemperature: "室外溫度",
    outdoorHumidity: "室外濕度",
    muziDigBig: '朩ふ汏汏'
};


// WEBPACK FOOTER //
// ./src/language/zh-TW.js